import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Button from '@material-ui/core/Button';
import Step from '@material-ui/core/Step';
import StepContent from '@material-ui/core/StepContent';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper'
import Typography from '@material-ui/core/Typography';

import { withDefaultStyles } from '../utils/material-ui/hoc';

const steps = ['Create a Sandbox', 'Checkout Demo', 'Build your own experience', 'Certification', 'Done']
const stepContent = {
    0: 'Create a sandbox account which complete isolate from customers.',
    1: 'Variety of demos available to showcase how we provide contextually relevant digital experiences to customers.',
    2: 'You can build your own solutions with helps of our ready to use integrations, or bring your own',
    3: 'Certification',
    4: 'Done'
}


class Welcome extends React.Component<any, any> {
    public render() {
        return (
            <div>
                <Typography variant='h4'>Welcome to PNS Sandbox</Typography>
                <Stepper activeStep={0} orientation="vertical">
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                            <StepContent>
                                <Typography>{stepContent[index]}</Typography>
                                <Button disabled={true}>Create a Sandbox</Button>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
            </div>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(withRouter(connect(
    mapStateToProps,
)(Welcome)));



// WEBPACK FOOTER //
// ./src/containers/welcome.tsx